(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('[data-delivery]').forEach(function (wrap) {
    var input = wrap.querySelector('[data-pin-input]');
    var btn = wrap.querySelector('[data-pin-check]');
    var result = wrap.querySelector('[data-pin-result]');
    if (!btn) return;
    function check() {
      var pin = (input.value || '').trim();
      result.hidden = false;
      if (!/^\d{6}$/.test(pin)) {
        result.className = 'sm-delivery__result is-err';
        result.textContent = 'Please enter a valid 6-digit PIN code.';
        return;
      }

      /* Delivery estimation by region (based on pincode zones from Assam) */
      var first = parseInt(pin.charAt(0));
      var first2 = parseInt(pin.substring(0, 2));
      var min, max, region;

      if (first2 >= 78 && first2 <= 79) {
        /* Assam, NE local — fastest */
        min = 2; max = 4; region = 'Assam / NE India';
      } else if (first === 7) {
        /* WB, Odisha, rest of NE */
        min = 3; max = 5; region = 'East India';
      } else if (first === 8) {
        /* Bihar, Jharkhand */
        min = 3; max = 6; region = 'East India';
      } else if (first === 1) {
        /* Delhi, Haryana, Punjab, HP, J&K */
        min = 4; max = 7; region = 'North India';
      } else if (first === 2) {
        /* UP, Uttarakhand */
        min = 4; max = 7; region = 'North India';
      } else if (first === 3) {
        /* Rajasthan, Gujarat */
        min = 5; max = 8; region = 'West India';
      } else if (first === 4) {
        /* Maharashtra, Goa */
        min = 5; max = 8; region = 'West India';
      } else if (first === 5) {
        /* AP, Telangana, Karnataka */
        min = 5; max = 8; region = 'South India';
      } else if (first === 6) {
        /* Kerala, TN */
        min = 5; max = 9; region = 'South India';
      } else {
        min = 5; max = 10; region = 'India';
      }

      var now = new Date();
      var d1 = new Date(now.getTime() + min * 86400000);
      var d2 = new Date(now.getTime() + max * 86400000);
      var opts = { day: 'numeric', month: 'short' };
      result.className = 'sm-delivery__result is-ok';
      result.innerHTML = '<i class="fas fa-check-circle"></i> Free delivery to ' + pin + ' (' + region + ') by <strong>' +
        d1.toLocaleDateString('en-IN', opts) + ' – ' + d2.toLocaleDateString('en-IN', opts) + '</strong>. COD available.';
    }
    btn.addEventListener('click', check);
    input.addEventListener('keypress', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
